module.exports = __webpack_public_path__ + "img/bitcoin-cash-bch-logo.86ef8464.png";